import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const PodiumIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 24 24"
    width={width}
    {...restProps}
  >
    <g>
      <path d="M12.5551 0.36027L13.4556 2.26346L15.4691 2.56857C15.9771 2.64576 16.1796 3.29668 15.8126 3.67064L14.3556 5.15188L14.6991 7.24335C14.7861 7.77117 14.2551 8.1733 13.8006 7.92451L12.0001 6.93667L10.1991 7.92451C9.74462 8.1733 9.21362 7.77117 9.30062 7.24335L9.64462 5.15188L8.18762 3.67064C7.82012 3.29668 8.02312 2.64576 8.53062 2.56857L10.5446 2.26346L11.4446 0.36027C11.6716 -0.12009 12.3281 -0.12009 12.5551 0.36027Z"/>
<path d="M7 11C7 9.89543 7.89543 9 9 9H15C16.1046 9 17 9.89543 17 11V13H22C23.1046 13 24 13.8954 24 15V24H22V15H17V24H15V11H9V24H7V17H2V24H0V17C0 15.8954 0.895431 15 2 15H7V11Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

PodiumIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default PodiumIcon;
